import { useTerritorialWidget } from '@/features/dashboard/hooks'
import { deriveTopTerritory } from '@/features/dashboard/utils/territory'

/**
 * Territorio con mayor actividad documental, para mostrarlo como contexto
 * global en el Topbar — reutiliza el mismo widget/cálculo que el hero del
 * Centro de Inteligencia (`DashboardHero`), nunca una segunda lógica
 * territorial.
 */
export function useActiveTerritory() {
  const query = useTerritorialWidget({})
  return { territory: deriveTopTerritory(query.data), isLoading: query.isLoading }
}
